export const GLOBAL = {
    MODULE: 'global',
};

export const ROUTES = {
    MAINTENANCE: 'portal.maintenance',
    NOTFOUND: 'portal.notfound',
};

export const EVENTS = {
    MODULE_LOADED: 'global.module-loaded',
    MODULE_EXITED: 'global.module-exited',
    MODULE_ENTERED: 'global.module-entered',
    SHOW_NOTIFICATION: 'show-notification',
    SHOW_MESSAGE: 'show-message',

    MAP_RELOAD: 'map.reload',
    MAP_REFRESH: 'map.refresh',
    MAP_IDENTIFY: 'map.identify',
    SELECT_FEATURE: 'map.select-feature',
    UNSELECT_FEATURE: 'map.unselect-feature',
    UPDATE_FEATURE: 'map.update-feature',
    HIGHLIGHT_FEATURE: 'map.highlight-feature',
    CLEAR_HIGHLIGHT_FEATURE: 'map.clear-highlight-feature',
    SHOW_MODAL_NEW_FEATURE: 'map.new-feature-show-modal',
    INITIALIZE_NEW_FEATURE: 'map.new-feature-initialize',
    FINISHED_NEW_FEATURE: 'map.new-feature-finished',
    CANCELED_NEW_FEATURE: 'map.new-feature-canceled',
};

export const MAP_ACTIONS = Object.freeze({
    DRAW: `global:draw`,
    DRAW_SELECT: `global:draw-select`,
    DRAW_FORM: `global:draw-alphanumeric-form`,
    DRAW_FEATUREABLE: `global:draw-featureable`,
});

export const MENU = {
    GROUP_PROPERTY: '_is_group',
}